import Privacy from "@/components/common/cathay-page/privacy.vue";

export default {
  install(Vue, options = {}) {
    Vue.component("Privacy", Privacy);
  },
};

export { Privacy };
